var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaisecomplaint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16,
    fill: "#E31837",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1426 12.3782V10.7467C20.1426 10.146 19.6556 9.65907 19.0549 9.65907C18.4542 9.65907 17.9673 10.146 17.9673 10.7467V9.65907C17.9673 9.05837 17.4803 8.57141 16.8796 8.57141C16.2789 8.57141 15.7919 9.05837 15.7919 9.65907V11.2905C15.7919 10.6899 15.305 10.2029 14.7043 10.2029C14.1036 10.2029 13.6166 10.6899 13.6166 11.2905V17.8165L13.0439 16.3847C12.7455 15.6386 11.9573 15.2117 11.1694 15.3693C11.0771 15.3877 10.9877 15.4184 10.9035 15.4605C10.3804 15.722 10.1683 16.3582 10.4299 16.8813L12.529 21.0794L12.5615 21.2093C13.1816 23.6899 15.4104 25.4301 17.9673 25.4301C20.37 25.4301 22.3179 23.4822 22.3179 21.0794V12.3782C22.3179 11.7775 21.8309 11.2905 21.2302 11.2905C20.6295 11.2905 20.1426 11.7775 20.1426 12.3782ZM20.1426 12.3782V16.7288M15.7919 10.2029V16.7288M17.9673 10.2029V15.6412",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaisecomplaint);
export default __webpack_public_path__ + "static/media/raisecomplaint.5ef3a59710efb53dd8523e1017293a21.svg";
export { ForwardRef as ReactComponent };